import {Box, Typography} from '@mui/material';
import {createFileRoute, useNavigate} from '@tanstack/react-router';
import {useTranslation} from 'tolgee';

import {Button} from '~components/common/buttons/Button';

export const Route = createFileRoute('/503')({
  component: ApiUnavailablePage,
});

function ApiUnavailablePage() {
  const {t} = useTranslation('common');
  const navigate = useNavigate();

  const handleRefresh = async () => {
    //  Do a hard refresh to clear the cache and check if the API is back online
    await navigate({to: '/'});
    window.location.reload();
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        height: '100%',
        paddingTop: 2,
        maxWidth: 500,
        margin: '0 auto',
      }}
    >
      <Box marginBottom={8}>
        <img src={'/images/maddox-ai-logo.svg'} alt='' width={120} />
      </Box>
      <Box marginBottom={8}>
        <Typography variant='h1' sx={{marginBottom: 3, fontWeight: 'bold'}}>
          {t('maintenance.title')}
        </Typography>
        <p>{t('maintenance.description')}</p>
        <p>{t('maintenance.apology')}</p>
        <p>&mdash; {t('maintenance.team')}</p>
      </Box>
      <Box>
        <Button eventName='refresh-button' variant='primary' onClick={handleRefresh}>
          {t('refresh')}
        </Button>
      </Box>
    </Box>
  );
}
